import Regex from './Regex'

export default class Url extends Regex {
  get ruleName () {
    return 'url'
  }

  passes () {
    return super.passes(/https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#()?&//=]*)/)
  }
}
